export default {
  root: {
    padding: '30px 70px'
  }
};
